import { createSlice } from "@reduxjs/toolkit";
import { doChangePassword, doLogin, doLogout } from "./auth.action";
import { setHeaderAuthorization } from "src/services/api";

interface AuthState {
  token: string | null;
  error: string | null;
  loading: boolean;
  user: {
    uid: string | null;
    email: string | null;
    role: string | null;
  } | null;
}

const initialState: AuthState = {
  token: localStorage.getItem("token") || null,
  error: null,
  loading: false,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Login
    builder
      .addCase(doLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doLogin.fulfilled, (state, action) => {
        const responseData = action.payload; 

        if (responseData) {
          const { authentication, uid, email, role } = responseData;

          state.loading = false;
          state.token = authentication?.accessToken || null;
          state.user = { uid, email, role };

          if (authentication?.accessToken) {
            setHeaderAuthorization(authentication.accessToken);
            localStorage.setItem("token",authentication.accessToken);
            sessionStorage.setItem("token", authentication.accessToken);
            sessionStorage.setItem("adminData", JSON.stringify(responseData)); 
          }
        } else {
          state.loading = false;
          state.error = "Invalid response data.";
        }
      })
      .addCase(doLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

      // change password 
      builder
      .addCase(doChangePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doChangePassword.fulfilled, (state,{payload}) => {
        state.loading = false;
        console.log(payload)
        state.error = payload as string;
      })
      .addCase(doChangePassword.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload as string;
      });


      // logout 
      builder
      .addCase(doLogout.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doLogout.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
        state.error = null;
        state.token = null;
        localStorage.removeItem("token");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("adminData");
        setHeaderAuthorization(null);
      })
      .addCase(doLogout.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload as string;
      });
  },
});

export default authSlice.reducer;